import type { Task } from './api';

/** A heartbeat is configured when there is reusable schedule or prompt state. */
export const isHeartbeatConfigured = (task: Task): boolean =>
  (task.heartbeat_interval_ms ?? 0) > 0;

/** Omitted is enabled for task payloads produced before the pause flag shipped. */
export const isHeartbeatEnabled = (task: Task): boolean =>
  isHeartbeatConfigured(task) && task.heartbeat_enabled !== false;

export interface HeartbeatIntervalOption {
  value: number;
  label: string;
}

export const HEARTBEAT_INTERVAL_OPTIONS: HeartbeatIntervalOption[] = [
  { value: 5, label: 'Every 5 minutes' },
  { value: 10, label: 'Every 10 minutes' },
  { value: 15, label: 'Every 15 minutes' },
  { value: 30, label: 'Every 30 minutes' },
  { value: 60, label: 'Every 1 hour' },
  { value: 120, label: 'Every 2 hours' },
];

export const DEFAULT_HEARTBEAT_MINUTES = 5;

const STORAGE_KEY = 'borgee:tasks:heartbeatMinutes';

export const loadPreferredHeartbeatMinutes = (): number => {
  try {
    const stored = Number(localStorage.getItem(STORAGE_KEY));
    return HEARTBEAT_INTERVAL_OPTIONS.some(o => o.value === stored) ? stored : DEFAULT_HEARTBEAT_MINUTES;
  } catch {
    return DEFAULT_HEARTBEAT_MINUTES;
  }
};

export const rememberHeartbeatMinutes = (minutes: number): void => {
  try {
    localStorage.setItem(STORAGE_KEY, String(minutes));
  } catch {}
};
